<template>
  <div class="manual-card">
    <div class="header">{{ $lang('面单库存') }}</div>
    <div class="content">
      <div class="manual-box">
        <img src="../images/op_icon.png" alt="" class="manual-icon" />
        <div>
          <span class="name">{{ $lang('面单库存') }}：</span>
          <span class="value">
            <count-to :start-val="0" :end-val="$store.state.base.user.stockCount || 0" :duration="2000" separator="," />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
export default {
  name: 'WaybillInventory',
  components: {
    CountTo,
  },
}
</script>

<style lang="scss" scoped>
.manual-card {
  box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .header {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
  }

  .content {
    margin: 0 auto;
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 144px;
    border-radius: 12px;
    padding: 12px;
    width: calc(100% - 32px);
    background-image: url('../images/op_bg.png');
    background-size: 100% 100%;
    .manual-box {
      text-align: center;
      .manual-icon {
        margin: 0 auto;
        font-size: 48px;
        color: #ff6b6b;
        margin-bottom: 10px;
        display: block;
      }
      .name {
        color: #666666;
      }
      .value {
        color: #222;
      }
    }
  }
}
</style>
